interface CheckboxProps {
  name: string;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  [key: string]: any;
}

export const Checkbox = ({ name, label, onChange, ...rest }: CheckboxProps) => {

  return (
    <div className="form-control">
      <label className="label cursor-pointer">
        <input type="checkbox" name={name} onChange={onChange} {...rest} className="checkbox" />
        <span className="label-text ml-2">{label}</span> 
      </label>
    </div>
  );
};
